import React from 'react';

const paths = {
    home: <><path d="m3 10 9-7 9 7v10a1 1 0 0 1-1 1h-5v-7H9v7H4a1 1 0 0 1-1-1Z"/></>,
    wifi: <><path d="M3 8a15 15 0 0 1 18 0M6 12a10 10 0 0 1 12 0m-9 4a5 5 0 0 1 6 0"/><circle cx="12" cy="20" r=".7"/></>,
    history: <><path d="M3 10a9 9 0 1 1 1 7M3 4v6h6m3-4v6l4 2"/></>,
    help: <><path d="M4 14v-3a8 8 0 0 1 16 0v3M4 12H2v6h4v-6Zm16 0h2v6h-4v-6Zm0 6v2h-8"/></>,
    settings: <><path d="M4 7h16M4 17h16"/><circle cx="9" cy="7" r="3"/><circle cx="15" cy="17" r="3"/></>,
    arrow: <path d="M5 12h14m-6-6 6 6-6 6"/>,
    back: <path d="M19 12H5m6-6-6 6 6 6"/>,
    chevron: <path d="m9 5 7 7-7 7"/>,
    down: <path d="m6 9 6 6 6-6"/>,
    plus: <path d="M12 5v14M5 12h14"/>,
    close: <path d="m6 6 12 12M6 18 18 6"/>,
    card: <><rect x="3" y="5" width="18" height="14" rx="3"/><path d="M3 10h18M7 15h4"/></>,
    shield: <><path d="m12 3 8 3v6c0 5-8 9-8 9s-8-4-8-9V6Z"/><path d="m8 12 3 3 5-6"/></>,
    bell: <><path d="M5 17h14l-2-4V9a5 5 0 0 0-10 0v4Zm5 3h4"/></>,
    user: <><circle cx="12" cy="8" r="4"/><path d="M4 21v-2a8 8 0 0 1 16 0v2"/></>,
    speed: <><path d="M4 19a10 10 0 1 1 16 0M12 13l5-6"/><circle cx="12" cy="14" r="2"/></>,
    download: <path d="M12 3v12m-5-5 5 5 5-5M4 17v4h16v-4"/>,
    upload: <path d="M12 16V4m-5 5 5-5 5 5M4 17v4h16v-4"/>,
    phone: <path d="m7 3 3 5-3 3a14 14 0 0 0 6 6l3-3 5 3c0 4-3 5-6 4A20 20 0 0 1 3 9C2 6 3 3 7 3Z"/>,
    logout: <><path d="M9 4H4v16h5m5-13 5 5-5 5M8 12h11"/></>,
    check: <path d="m5 12 4 4L19 6"/>,
    globe: <><circle cx="12" cy="12" r="9"/><ellipse cx="12" cy="12" rx="4" ry="9"/><path d="M3 12h18"/></>,
    eye: <><path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/></>,
};
export function Icon({name, size = 22, ...props}) {
    return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.65" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>{paths[name] || paths.wifi}</svg>;
}
export const money = value => value == null || value === '' || !Number.isFinite(Number(value)) ? '—' : Number(value).toLocaleString('ru-RU', {maximumFractionDigits: 2});
export const dateLabel = value => value && !Number.isNaN(new Date(value).getTime()) ? new Date(value).toLocaleDateString('ru-RU', {day: 'numeric', month: 'long', year: 'numeric'}) : 'Дата не указана';
export const speedLabel = value => Number(value) > 0 ? `${money(Number(value) / 1000)} Мбит/с` : 'Не указана';
export const trafficLabel = value => value == null ? '—' : `${money(Number(value) / 1073741824)} ГБ`;
export function connectionsFor(point) {
    return Object.entries(point?.points || {}).flatMap(([address, group]) => Object.entries(group?.accounts || {}).map(([id, account]) => ({id: `${address}:${id}`, address, account})));
}
export function Button({children, className = '', variant = 'primary', ...props}) {
    return <button className={`button ${variant} ${className}`} {...props}>{children}</button>;
}
export function Notice({children, error = false}) {
    return <div className={`notice ${error ? 'error' : ''}`} role={error ? 'alert' : 'status'}>{children}</div>;
}
export function Empty({icon = 'wifi', title, children}) {
    return <div className="empty"><span className="icon-tile"><Icon name={icon} size={28}/></span><h3>{title}</h3><div className="muted">{children}</div></div>;
}
export function PageHeading({eyebrow, title, children}) {
    return <div className="page-heading"><div>{eyebrow && <p className="eyebrow">{eyebrow}</p>}<h1>{title}</h1></div>{children}</div>;
}
export function DetailRow({label, children}) {
    return <div className="detail-row"><span className="muted">{label}</span><strong>{children ?? '—'}</strong></div>;
}
